module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    attrs: {
      "clearable": true,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.treeData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "show-checkbox": _vm.checkable,
      "highlight-current": "",
      "filter-node-method": _vm.filterNode,
      "default-expand-all": true
    },
    on: {
      "show": _vm.clearFilter,
      "check": _vm.handleCheck,
      "node-click": _vm.handleNodeClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          class: {
            'disabled-text': data.disable
          }
        }, [_vm._v("\n      " + _vm._s(data.name) + "\n    ")])
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95e68aae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AgencyTree/AgencyTreeCore.vue
// module id = 760
// module chunks = 8